import { IRest } from './rest.interface';
import { EnumAliasType, EnumAnnouncementType } from './enums';

export class AnnouncementAlias implements IRest {
    className = 'Pseudônimo para as instâncias relacionadas ao Edital';

    id!: number;
    name!: string;
    item!: EnumAliasType;
    itemId!: number;
    jobId!: number;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            name: this.name,
            principalType: this.item,
            principalId: this.itemId,
            jobId: this.jobId
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.name = data['name'] || '';
            this.item = <EnumAliasType>(data['principalType'] || EnumAliasType.Subject);
            this.itemId = data['principalId'] || 0;
            this.jobId = data['jobId'] || 0;
        }
        return this;
    }

}

export class AnnouncementInfoFromJobs implements IRest {
    className = 'Informações de Cargos do Edital';

    jobsCount!: number;
    totalVacancies!: number;
    minWage!: number;
    maxWage!: number;
    averageWage!: number;
    minTestDate!: Date;
    maxTestDate!: Date;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            jobsCount: this.jobsCount,
            totalVacancies: this.totalVacancies,
            minWage: this.minWage,
            maxWage: this.maxWage,
            averageWage: this.averageWage,
            minTestDate: this.minTestDate.toISOString(),
            maxTestDate: this.maxTestDate.toISOString()
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.jobsCount = data['jobsCount'] || 0;
            this.totalVacancies = data['totalVacancies'] || 0;
            this.minWage = data['minWage'] || 0;
            this.maxWage = data['maxWage'] || 0;
            this.averageWage = data['averageWage'] || 0;
            this.minTestDate = data['minTestDate'] ? new Date(data['minTestDate']) : new Date(2000, 0);
            this.maxTestDate = data['maxTestDate'] ? new Date(data['maxTestDate']) : new Date(2000, 0);
        }
        return this;
    }

}

export class AnnouncementCategory implements IRest {
    className = 'Categoria do Edital';

    id!: number;
    name!: string;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            name: this.name
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.name = data['name'] || '';
        }
        return this;
    }

}

export class Announcement implements IRest {
    className = 'Edital';

    id!: number;
    name!: string;
    type!: EnumAnnouncementType;
    categories!: Array<AnnouncementCategory>;
    description?: string;
    initials!: string;
    datePublication!: Date;
    dateClosing!: Date;
    dateInitialSubscription!: Date;
    dateFinalSubscription!: Date;
    link?: string;
    state!: any;
    city?: string;
    instituteId!: number;
    instituteImage!: string; //Uso Interno
    examiningBoardId!: number;
    jobs?: any;
    infoFromJobs!: AnnouncementInfoFromJobs;
    active!: boolean;
    canceled!: boolean;
    authorized!: boolean;
    expected!: boolean;
    updatedAt!: Date;
    createdAt!: Date;

    plansCount?: number; //Modo administrativo
    isTrending?: boolean; // em alta

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            name: this.name,
            type: this.type,
            categories: this.categories.map(c => c.Serialize()),
            description: this.description,
            initials: this.initials,
            publicationDate: this.datePublication,
            closingDate: this.dateClosing,
            initialRegistrationDate: this.dateInitialSubscription,
            finalRegistrationDate: this.dateFinalSubscription,
            link: this.link,
            state: this.state,
            city: this.city,
            instituteId: this.instituteId || undefined,
            examiningBoardId: this.examiningBoardId || undefined,
            infoFromJobs: this.infoFromJobs.Serialize(),
            active: this.active,
            canceled: this.canceled,
            authorized: this.authorized,
            expected: this.expected,
            updatedAt: this.updatedAt.toISOString()
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.name = data['name'] || '';
            this.type = data['type'] || EnumAnnouncementType.ConcursoPublico;
            this.categories = (data['categories'] || []).map((c: any) => new AnnouncementCategory(c));
            this.description = data['description'] || '';
            this.initials = data['initials'] || '';
            this.datePublication = data['publicationDate'] ? new Date(data['publicationDate']) : new Date(2000, 0);
            this.dateClosing = data['closingDate'] ? new Date(data['closingDate']) : new Date(2000, 0);
            this.dateInitialSubscription = data['initialRegistrationDate'] ? new Date(data['initialRegistrationDate']) : new Date(2000, 0);
            this.dateFinalSubscription = data['finalRegistrationDate'] ? new Date(data['finalRegistrationDate']) : new Date(2000, 0);
            this.link = data['link'] || '';
            this.state = data['state'] || '';
            this.city = data['city'] || '';
            this.instituteId = data['instituteId'] || 0;
            this.examiningBoardId = data['examiningBoardId'] || 0;
            this.jobs = data['jobs'] || [];
            this.infoFromJobs = new AnnouncementInfoFromJobs(data['infoFromJobs'] || {});
            this.active = data['active'] || false;
            this.canceled = data['canceled'] || false;
            this.authorized = data['authorized'] || false;
            this.expected = data['expected'] || false;
            this.updatedAt = data['updatedAt'] ? new Date(data['updatedAt']) : new Date(2000, 0);
            this.createdAt = data['createdAt'] ? new Date(data['createdAt']) : new Date(2000, 0);
            this.plansCount = !isNaN(data['plansCount'])? data['plansCount']  : undefined;
            this.isTrending = data['isTrending'] || false;
        }
        return this;
    }

}
